module.exports = __webpack_public_path__ + "static/media/sistema-condutores-plano-starter.7b839ec9.png";